const SERVICE_IDENTIFIER = {
  TaroElement: 'TaroElement',
  TaroElementFactory: 'Factory<TaroElement>',
  TaroText: 'TaroText',
  TaroTextFactory: 'Factory<TaroText>',
  TaroNodeImpl: 'TaroNodeImpl',
  TaroElementImpl: 'TaroElementImpl',
  Hooks: 'hooks',
  onRemoveAttribute: 'onRemoveAttribute',
  getLifecycle: 'getLifecycle',
  getPathIndex: 'getPathIndex',
  getEventCenter: 'getEventCenter',
  isBubbleEvents: 'isBubbleEvents',
  getSpecialNodes: 'getSpecialNodes',
  eventCenter: 'eventCenter',
  modifyMpEvent: 'modifyMpEvent',
  modifyTaroEvent: 'modifyTaroEvent',
  batchedEventUpdates: 'batchedEventUpdates',
  mergePageInstance: 'mergePageInstance',
  createPullDownComponent: 'createPullDownComponent',
  getDOMNode: 'getDOMNode',
  initNativeApi: 'initNativeApi',
  modifyHydrateData: 'modifyHydrateData',
  modifySetAttrPayload: 'modifySetAttrPayload',
  modifyRmAttrPayload: 'modifyRmAttrPayload',
  onAddEvent: 'onAddEvent',
  patchElement: 'patchElement'
}

export default SERVICE_IDENTIFIER
